import React from "react";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import Badge from './Badge.js';
    
export default class OffersTable extends React.Component {

  render(){
    return (
        <div className="tableContainer tableWidth">          
            <table className="table table-bordered">
                <thead>
                    <tr>
                        {this.props.data[0]["dataColumns"].map((indexedDB, iCounter)=>{
                            if(iCounter === 0)
                            return(
                                <th style={{textAlign:'center'}}>{indexedDB}</th>
                            )
                            else if(indexedDB === "PROFILE EVALUATION")
                            return(
                                <th>
                                    <Badge data={indexedDB}/>
                                </th>
                            )
                            return (<th>{indexedDB}</th>)
                        })}
                    </tr>
                </thead>
            <tbody>
                {this.props.data[0]["dataRows"].map((indexedDB)=>{
                    return(
                        <tr>
                        {indexedDB.split("$%$").map((index, iCounter)=>{
                            return(
                                index === "1"?
                                <td><FiberManualRecordIcon style={{fontSize:12}}/></td>
                                : index === "0"?<td></td>
                                : iCounter===0?
                                <td style={{padding:'6px', textAlign:'left', fontSize:16}} dangerouslySetInnerHTML={{__html: index}}/>
                                :<td style={{fontSize:16}} dangerouslySetInnerHTML={{__html: index}}></td>
                            )
                        })}
                        </tr>
                    )
                })

                }
            </tbody>
            </table>
        </div>
    );
  }
}

